/**
 * This file concerns itself only with the mobile menu
 */

// concerning the opening and closing of the menu
const bodyScrollLock = require('body-scroll-lock');

const { disableBodyScroll } = bodyScrollLock;
const { enableBodyScroll } = bodyScrollLock;
const { clearAllBodyScrollLocks } = bodyScrollLock;

let open = false;
const btn = document.querySelector('.js-open-mobile-menu');
const header = document.querySelector('.js-mobile-menu-header');
const menu = document.querySelector('.js-mobile-menu');
const backLinks = document.querySelectorAll('.js-mobile-menu-back');

// concerning the expansion of sub menus
const subMenuLinks = document.querySelectorAll('.js-mobile-sub-menu-link');
const allSubMenus = document.querySelectorAll('.js-mobile-menu-sub');
const blockLinks = document.querySelectorAll('.js-mobile-menu-block');

function closeAllSubMenus(e = null) {
    if (e) {
        e.preventDefault();
    }

    header.classList.remove('hidden');

    allSubMenus.forEach((child) => {
        child.classList.remove('open');
        child.classList.remove('active');
    });

    blockLinks.forEach((link) => {
        const children = link.parentElement.querySelectorAll('.open');
        children.forEach((child) => {
            child.classList.remove('open');
            enableBodyScroll(child);
        });
    });
    disableBodyScroll(menu);
}

function handleSubMenuLink(e) {
    e.preventDefault();
    const link = e.target;
    const subMenu = link.parentElement.querySelector('.js-mobile-menu-sub');
    closeAllSubMenus();
    header.classList.add('hidden');
    subMenu.classList.add('open');
    enableBodyScroll(menu);
    disableBodyScroll(subMenu);

    setTimeout(() => {
        subMenu.classList.add('active');
    }, 150);
}

// concerning the expansion of block links

function handleLink(e) {
    const link = e.target;
    const children = link.parentElement.querySelectorAll('.js-mobile-menu-block-child');
    if (link.parentElement.classList.contains('js-mobile-menu-block')) {
        e.preventDefault();
    }

    if (link.cooling === true) return;

    link.cooling = true;
    setTimeout(() => {
        link.cooling = false;
    }, 150);
    link.classList.toggle('open');
    children.forEach((child) => {
        child.classList.toggle('open');
    });
}

// concerning opening / closing the navigation initially
function handleBtn(e) {
    e.preventDefault();
    open = !open;
    header.classList.toggle('open');
    menu.classList.toggle('open');
    closeAllSubMenus(); // reset the menus

    if (open) {
        disableBodyScroll(menu);
    } else {
        clearAllBodyScrollLocks();
    }
}

if (btn) {
    btn.addEventListener('click', handleBtn);
    btn.addEventListener('touchstart', handleBtn);
}

if (backLinks) {
    backLinks.forEach((link) => {
        link.addEventListener('click', closeAllSubMenus);
        link.addEventListener('tap', closeAllSubMenus);
    });
}

if (blockLinks) {
    blockLinks.forEach((link) => {
        link.addEventListener('click', handleLink);
        link.addEventListener('tap', handleLink);
    });
}

if (subMenuLinks) {
    subMenuLinks.forEach((link) => {
        link.addEventListener('click', handleSubMenuLink);
        link.addEventListener('tap', handleSubMenuLink);
    });
}
